export default function Strings() {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 28.8 42.9"
      // style="enable-background:new 0 0 28.8 42.9;"
      xmlSpace="preserve"
    >
      <g id="Group_11668" transform="translate(-19396.496 -3697.914)">
        <g id="Path_2220">
          <path
            className="st0"
            d="M19406.1,3740.8c-2,0-3.9-0.2-4.7-0.2l-0.3,0c-0.4,0-0.7-0.2-0.8-0.4c-0.3-0.4-0.3-0.9-0.3-1
                c0-0.4-0.1-1.9,0-2.3c0.1-0.6,0.7-0.9,1.2-0.8c1.6,0.3,3.2,0.4,4.7,0.4c1.6,0,3.3-0.2,4.3-0.3c0.4,0,0.7-0.1,0.9-0.1
                c0.5,0,0.8,0.1,1,0.4c0.2,0.2,0.3,0.5,0.3,0.8c0,0.2-0.1,2-0.1,2.3c-0.1,0.5-0.6,0.9-1.4,0.9c0,0-2.4,0.2-4.8,0.3
                C19406.2,3740.8,19406.1,3740.8,19406.1,3740.8z M19401.2,3739.3l0.2,0c0.8,0.1,2.8,0.2,4.7,0.2c2.3,0,4.7-0.2,4.7-0.2
                c0.1,0,0.2,0,0.3,0c0-0.4,0.1-1.3,0.1-1.9c0,0-0.1,0-0.1,0c-0.1,0-0.4,0-0.7,0.1c-1,0.1-2.7,0.3-4.4,0.3c-1.6,0-3.2-0.2-4.8-0.4
                C19401.2,3737.7,19401.2,3738.5,19401.2,3739.3L19401.2,3739.3z M19401.3,3739.4L19401.3,3739.4L19401.3,3739.4z M19411.2,3737.3
                C19411.2,3737.3,19411.2,3737.3,19411.2,3737.3C19411.2,3737.3,19411.2,3737.3,19411.2,3737.3z M19400.6,3737L19400.6,3737
                L19400.6,3737z"
          />
        </g>
        <g id="Path_2221">
          <path
            className="st0"
            d="M19401.1,3737.3c-0.3,0-0.6-0.2-0.6-0.6l-2-28.5l-1.8-6.6c-0.2-0.3-0.2-0.9,0.2-1.3c0.1-0.1,1.1-1.1,2-2
                c0.2-0.2,0.5-0.4,0.8-0.4c0.3,0,0.6,0.1,0.9,0.3c0.1,0,0.1,0.1,0.2,0.2c0.4,0.4,1.6,1.6,1.9,1.9c0.2,0.2,0.5,0.4,0.5,0.8v0.1
                c1-0.3,2.8-0.6,4.2,0.4c1.7,1.4,3.2,3.1,4.5,4.9l0.2,0.2c0.8,1,1.6,1.9,2.7,1.6c1.9-0.6,3.8-1.2,5.7-2c0.1,0,2.7-1.2,4.1,0.1
                c1.5,1.4,0.9,3,0.5,3.9c-0.4,1.1-9.3,18.8-9.7,19.6c-0.1,0.3-0.5,0.4-0.8,0.3c-0.3-0.1-0.4-0.5-0.3-0.8c3.2-6.4,9.3-18.7,9.7-19.5
                c0.5-1.2,0.6-1.8-0.2-2.6c-0.7-0.7-2.3-0.1-2.8,0.1c-1.9,0.8-3.9,1.5-5.9,2.1c-2,0.4-3.2-1.1-4-2.1l-0.2-0.2
                c-1.2-1.8-2.6-3.3-4.3-4.6c-1.6-1.1-3.8,0.1-3.8,0.1l-0.9,0.4l0-1.8c0,0-1.5-1.5-2-2c-0.3,0.3-1.5,1.6-2,2c0,0,0,0.1,0,0.1
                l1.9,6.9l2,28.6C19401.7,3737,19401.4,3737.2,19401.1,3737.3C19401.1,3737.3,19401.1,3737.3,19401.1,3737.3z"
          />
        </g>
        <g id="Path_2222">
          <path
            className="st0"
            d="M19410.4,3737.5c-0.1,0-0.2,0-0.3-0.1c-0.3-0.2-0.4-0.5-0.3-0.8l2.1-3.9c0.2-0.3,0.5-0.4,0.8-0.3
                c0.3,0.2,0.4,0.5,0.3,0.8l-2.1,3.9C19410.9,3737.4,19410.7,3737.5,19410.4,3737.5z"
          />
        </g>
        <g id="Line_48">
          <path
            className="st0"
            d="M19413.5,3732c-0.1,0-0.2,0-0.3-0.1c-0.3-0.1-0.4-0.5-0.3-0.8l0.3-0.6c0.1-0.3,0.5-0.4,0.8-0.3
                c0.3,0.1,0.4,0.5,0.3,0.8l-0.3,0.6C19413.9,3731.9,19413.7,3732,19413.5,3732z"
          />
        </g>
        <g id="Path_2223">
          <path
            className="st0"
            d="M19403.7,3735.7c-0.1,0-0.3,0-0.4-0.1c-0.3-0.2-0.3-0.5-0.3-0.6l-2.2-27.4c0-1.3,0.6-2.6,1.7-3.3
                c1.5-1,3.6-0.8,5,0.5c0.8,0.8,2,2.2,3,3.3c0.4,0.5,0.8,0.9,1.1,1.3c0.9,1,1.7,1.9,4.7,1.6c1.5-0.1,2.9-0.4,4.3-1
                c0.3-0.1,0.7-0.1,0.9,0.2c0.2,0.2,0.3,0.5,0.1,1c-0.3,0.5-4,6.9-8.3,12.9c-4.1,5.9-8.4,10.9-8.5,10.9c-0.2,0.2-0.4,0.5-0.7,0.6
                l-0.2,0.1C19403.9,3735.7,19403.8,3735.7,19403.7,3735.7z M19404.2,3734.9L19404.2,3734.9L19404.2,3734.9z M19404.6,3704.8
                c-0.5,0-1.1,0.2-1.5,0.5c-0.7,0.5-1.2,1.3-1.1,2.2l2.1,26.4c1-1.1,4.6-5.5,8.2-10.6c3.3-4.7,6.5-9.8,7.7-11.8
                c-1.2,0.4-2.4,0.6-3.6,0.7c-3.3,0.3-4.5-0.7-5.7-2c-0.3-0.3-0.7-0.8-1.1-1.3c-1-1.1-2.2-2.5-3-3.3
                C19406,3705.1,19405.3,3704.8,19404.6,3704.8z"
          />
        </g>
        <g id="Path_2224">
          <path
            className="st0"
            d="M19399.1,3708.9C19399.1,3708.9,19399.1,3708.9,19399.1,3708.9c-0.4,0-0.6-0.3-0.6-0.7
                c0.1-1.6,0.5-3.1,1.1-4.5c0.6-1.1,1.5-1.9,2.6-2.4c0.3-0.1,0.7,0,0.8,0.3c0.1,0.3,0,0.7-0.3,0.8c-0.8,0.3-1.5,1-1.9,1.8
                c-0.5,1.3-0.9,2.7-1,4.1C19399.7,3708.7,19399.4,3708.9,19399.1,3708.9z"
          />
        </g>
        <g id="Path_2225">
          <path
            className="st0"
            d="M19405,3734.2L19405,3734.2c-0.3,0-0.6-0.3-0.6-0.6l0-29.3c0-0.3,0.3-0.6,0.6-0.6l0,0c0.3,0,0.6,0.3,0.6,0.6
                l0,29.3C19405.6,3733.9,19405.3,3734.2,19405,3734.2z"
          />
        </g>
        <g id="Path_2227">
          <path
            className="st0"
            d="M19409.1,3729C19409.1,3729,19409.1,3729,19409.1,3729c-0.3,0-0.6-0.3-0.6-0.6l0.4-20.2
                c0-0.3,0.3-0.6,0.6-0.6c0,0,0,0,0,0c0.3,0,0.6,0.3,0.6,0.6l-0.4,20.2C19409.7,3728.8,19409.4,3729,19409.1,3729z"
          />
        </g>
        <g id="Path_2230">
          <path
            className="st0"
            d="M19413.1,3723.5C19413.1,3723.5,19413.1,3723.5,19413.1,3723.5c-0.3,0-0.6-0.3-0.6-0.6l0.4-11.4
                c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6l-0.4,11.4C19413.7,3723.2,19413.5,3723.5,19413.1,3723.5z"
          />
        </g>
        <g id="Path_2229">
          <path
            className="st0"
            d="M19417.7,3716.6c-0.3,0-0.6-0.3-0.6-0.6v-4.5c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6v4.5
                C19418.3,3716.3,19418,3716.6,19417.7,3716.6z"
          />
        </g>
      </g>
    </svg>
  );
}
